/* ==========================================================================
   KCONV — Adaptieve winkelwagen (client)
   - Zelfstandige AJAX-cart: qty/remove/bulk/discount via Cart API
   - Ververst #Main-Cart-Details met behoud van ?view=... (test-template)
   - ETA ("Morgen in huis"), zoeken, groepen in-/uitklappen, undo, analytics
   Raakt geen kernbestanden aan.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kconvCartInit) return;
  window.__kconvCartInit = true;

  var DETAILS = '#Main-Cart-Details';
  var busy = false;
  var refreshing = false;

  /* ------------------------------------------------------------------ utils */
  function root() { return document.querySelector('.kconv-cart'); }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }
  function getCart() { return fetchJSON('/cart.js'); }

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }
  function money(cents) {
    try {
      if (typeof webvista !== 'undefined' && webvista && typeof webvista.formatPriceAmount === 'function') {
        var out = webvista.formatPriceAmount(cents, activeCurrency());
        if (out) return out;
      }
    } catch (e) {}
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: activeCurrency() }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function analytics(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'kconv_cart_' + event }, payload || {}));
    } catch (e) {}
  }

  /* ------------------------------------------------------ header cart bubble */
  function updateBadges() {
    var targets = [
      { id: 'Top-Cart-Bubble', section: 'cart-icon-bubble' },
      { id: 'Bottom-Cart-Bubble', section: 'cart-icon-bubble' }
    ];
    var params = targets.map(function (t) { return t.section; }).join(',');
    var base = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    fetch(base + '?sections=' + params)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        targets.forEach(function (t) {
          var el = document.getElementById(t.id);
          if (el && sections[t.section]) {
            var frag = new DOMParser().parseFromString(sections[t.section], 'text/html').querySelector('.shopify-section');
            if (frag) el.innerHTML = frag.innerHTML;
          }
        });
      })
      .catch(function () {});
  }

  function broadcast(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'kconv-cart' } }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'kconv-cart' } }));
    } catch (e) {}
    try {
      if (typeof webvista !== 'undefined' && webvista.publish && typeof PUB_SUB_EVENTS !== 'undefined') {
        webvista.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kconv-cart', cartData: cart });
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------- refresh markup */
  function refresh() {
    refreshing = true;
    var url = window.location.pathname + window.location.search;
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(DETAILS);
        var current = document.querySelector(DETAILS);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          // data-cart-mode kan gewijzigd zijn (regels toegevoegd/verwijderd)
          var freshRoot = doc.querySelector('.kconv-cart');
          if (freshRoot && root()) {
            root().setAttribute('data-cart-mode', freshRoot.getAttribute('data-cart-mode'));
          }
        }
        afterRender();
        initRecs();
        updateBadges();
        return getCart();
      })
      .then(function (cart) { broadcast(cart); return cart; })
      .catch(function () { window.location.reload(); })
      .then(function () { refreshing = false; });
  }

  /* ----------------------------------- Cart Section Rendering (lichte refresh) */
  function sectionId() {
    var el = document.getElementById('Main-Cart');
    return el ? el.getAttribute('data-section-id') : null;
  }
  // Voeg sections-parameters toe aan een mutatie-body zodat de respons
  // alleen de sectie-HTML teruggeeft i.p.v. dat wij de hele pagina ophalen.
  function withSections(body) {
    var id = sectionId();
    if (id) {
      body.sections = id;
      body.sections_url = window.location.pathname + window.location.search;
    }
    return body;
  }
  // Verwerk een mutatie-respons: gebruik meegeleverde sectie-HTML, val anders
  // terug op de volledige pagina-fetch (refresh).
  function applyResponse(res) {
    if (res && res.sections && sectionId() && res.sections[sectionId()]) {
      return renderFromSections(res.sections[sectionId()]);
    }
    return refresh();
  }
  function renderFromSections(html) {
    if (!html) return refresh();
    refreshing = true;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector(DETAILS);
      var current = document.querySelector(DETAILS);
      if (!fresh || !current) { refreshing = false; return refresh(); }
      current.innerHTML = fresh.innerHTML;
      var freshWrap = doc.getElementById('Main-Cart');
      if (freshWrap && root()) root().setAttribute('data-cart-mode', freshWrap.getAttribute('data-cart-mode'));
      afterRender();
      initRecs();
      updateBadges();
    } catch (e) { refreshing = false; return refresh(); }
    return getCart()
      .then(function (cart) { broadcast(cart); return cart; })
      .then(function () { refreshing = false; });
  }

  function lockLine(key, on) {
    var el = document.querySelector('[data-kconv-ci][data-line-key="' + cssEscape(key) + '"]');
    if (el) el.classList.toggle('is-loading', !!on);
  }
  function cssEscape(v) { return String(v).replace(/["\\]/g, '\\$&'); }

  /* ------------------------------------------------------------ cart changes */
  function changeLine(key, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    lockLine(key, true);
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ id: key, quantity: quantity }))
    })
      .then(function (res) { return applyResponse(res); })
      .then(function () { analytics('update', { line: key, quantity: quantity }); })
      .catch(function (err) { handleError(err); })
      .then(function () { busy = false; lockLine(key, false); });
  }

  function bulkUpdate(updates) {
    if (busy) return Promise.resolve();
    busy = true;
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ updates: updates }))
    })
      .then(function (res) { return applyResponse(res); })
      .catch(function (err) { handleError(err); })
      .then(function () { busy = false; });
  }

  function applyDiscount(code) {
    if (busy || !code) return Promise.resolve();
    busy = true;
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ discount: code }))
    })
      .then(function (res) { return applyResponse(res); })
      .catch(function (err) { handleError(err); })
      .then(function () { busy = false; });
  }

  function handleError(err) {
    var msg = 'Er ging iets mis. Probeer het opnieuw.';
    if (err && typeof err.json === 'function') {
      return err.json().then(function (d) { toast(d.description || d.message || msg); }).catch(function () { toast(msg); });
    }
    toast(msg);
  }

  /* --------------------------------------------------------- remove + undo */
  function removeWithUndo(key) {
    getCart().then(function (cart) {
      var line = (cart.items || []).filter(function (it) { return it.key === key; })[0];
      var undo = line ? { id: line.variant_id, quantity: line.quantity, properties: line.properties || {} } : null;
      changeLine(key, 0).then(function () {
        analytics('remove', { line: key });
        if (undo) offerUndo(undo);
      });
    });
  }

  function offerUndo(item) {
    toast('Verwijderd', function () {
      var body = { items: [{ id: item.id, quantity: item.quantity, properties: item.properties }] };
      if (busy) return;
      busy = true;
      fetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(withSections(body))
      })
        .then(function (res) { return applyResponse(res); })
        .catch(function (err) { handleError(err); })
        .then(function () { busy = false; });
    });
  }

  /* -------------------------------------------------------------------- toast */
  var toastTimer = null;
  function toast(text, undoFn) {
    var box = document.getElementById('kconv-cart-toast');
    if (!box) {
      box = document.createElement('div');
      box.id = 'kconv-cart-toast';
      box.style.cssText = 'position:fixed;left:50%;bottom:80px;transform:translateX(-50%);z-index:60;background:#111;color:#fff;padding:12px 16px;border-radius:999px;display:flex;gap:14px;align-items:center;font-size:14px;box-shadow:0 8px 24px rgba(0,0,0,.25);opacity:0;transition:opacity .2s ease';
      document.body.appendChild(box);
    }
    box.innerHTML = '<span></span>';
    box.firstChild.textContent = text;
    if (undoFn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = 'Ongedaan maken';
      b.style.cssText = 'background:transparent;border:0;color:#ffb27a;font-weight:700;cursor:pointer;font:inherit';
      b.addEventListener('click', function () { hideToast(); undoFn(); });
      box.appendChild(b);
    }
    requestAnimationFrame(function () { box.style.opacity = '1'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, undoFn ? 6000 : 3000);
  }
  function hideToast() {
    var box = document.getElementById('kconv-cart-toast');
    if (box) box.style.opacity = '0';
  }

  /* --------------------------------------------------------------- ETA logic */
  function isWeekend(d) { var w = d.getDay(); return w === 0 || w === 6; }
  function nowInTz(tz) {
    try { var d = new Date(new Date().toLocaleString('en-US', { timeZone: tz })); if (!isNaN(d.getTime())) return d; } catch (e) {}
    return new Date();
  }
  function computeDelivery(workdays, cutoff, tz) {
    var now = nowInTz(tz);
    var p = (cutoff || '17:00').split(':');
    var ch = parseInt(p[0], 10); var cm = parseInt(p[1], 10) || 0;
    if (isNaN(ch)) ch = 17;
    var passed = now.getHours() > ch || (now.getHours() === ch && now.getMinutes() >= cm);
    var dispatch = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (passed) dispatch.setDate(dispatch.getDate() + 1);
    while (isWeekend(dispatch)) dispatch.setDate(dispatch.getDate() + 1);
    var delivery = new Date(dispatch); var added = 0;
    var n = parseInt(workdays, 10); if (isNaN(n) || n < 0) n = 1;
    while (added < n) { delivery.setDate(delivery.getDate() + 1); if (!isWeekend(delivery)) added++; }
    return { now: now, delivery: delivery };
  }
  function formatEta(el) {
    var res = computeDelivery(el.getAttribute('data-workdays'), el.getAttribute('data-cutoff'), el.getAttribute('data-tz') || 'Europe/Amsterdam');
    var locale = el.getAttribute('data-locale') || 'nl';
    var today = new Date(res.now.getFullYear(), res.now.getMonth(), res.now.getDate());
    var diff = Math.round((res.delivery - today) / 86400000);
    var dateStr;
    try { dateStr = res.delivery.toLocaleDateString(locale, { day: 'numeric', month: 'long' }); }
    catch (e) { dateStr = res.delivery.getDate() + '/' + (res.delivery.getMonth() + 1); }
    var wd = '';
    try { wd = res.delivery.toLocaleDateString(locale, { weekday: 'long' }); } catch (e) {}
    var dateFull = (wd ? wd + ' ' : '') + dateStr;

    var label;
    if (el.getAttribute('data-eta-mode') === 'phrase') {
      // Groepskop: "Verwachte levering op woensdag 29 juli"
      label = (el.getAttribute('data-phrase-on') || 'Verwachte levering op') + ' ' + dateFull;
    } else {
      // Per item: "Verwachte leverdatum: woensdag 29 juli"
      label = (el.getAttribute('data-date-prefix') || 'Verwachte leverdatum:') + ' ' + dateFull;
    }
    var val = el.querySelector('[data-kconv-cart-eta-value]');
    if (val) val.textContent = label;
  }
  function applyEtas() { $all('[data-kconv-cart-eta]').forEach(formatEta); }

  /* ------------------------------------------------------------ search filter */
  function runSearch(term) {
    term = (term || '').trim().toLowerCase();
    var searching = term.length > 0;
    var kc = root();
    if (kc) kc.classList.toggle('is-searching', searching);

    if (searching) {
      // Vouw alles uit zodat de zoekopdracht ook verborgen/ingeklapte items vindt
      $all('.kconv-group').forEach(function (g) {
        g.classList.remove('is-collapsed');
        g.setAttribute('aria-collapsed', 'false');
        var head = $('[data-kconv-group-toggle]', g);
        if (head) head.setAttribute('aria-expanded', 'true');
      });
      $all('.kconv-ci--overflow').forEach(function (w) { w.hidden = false; });
      $all('[data-kconv-show-more]').forEach(function (b) { b.style.display = 'none'; });
    } else {
      // Herstel de ingeklapte staat + verberg overflow-rijen weer
      restoreCollapse();
      $all('.kconv-ci--overflow').forEach(function (w) { w.hidden = true; });
      $all('[data-kconv-show-more]').forEach(function (b) {
        b.style.display = '';
        b.setAttribute('aria-expanded', 'false');
        if (b.dataset.labelMore) b.textContent = b.dataset.labelMore;
      });
    }

    $all('.kconv-ci--row').forEach(function (row) {
      var wrap = row.closest('.kconv-ci-wrap') || row;
      var hit = !searching || (row.getAttribute('data-search') || '').indexOf(term) !== -1;
      wrap.style.display = hit ? '' : 'none';
    });

    // Verberg groepen zonder treffers tijdens het zoeken
    $all('.kconv-group').forEach(function (g) {
      if (!searching) { g.style.display = ''; return; }
      var visible = $all('.kconv-ci-wrap', g).some(function (w) { return w.style.display !== 'none'; });
      g.style.display = visible ? '' : 'none';
    });
  }

  /* ------------------------------------------------------------ bulk select */
  function selectedKeys() {
    return $all('[data-kconv-select]:checked').map(function (c) { return c.value; });
  }
  function syncBulk() {
    var keys = selectedKeys();
    var bar = $('[data-kconv-bulk]');
    var cnt = $('[data-kconv-bulk-count]');
    if (bar) bar.hidden = keys.length === 0;
    if (cnt) cnt.textContent = keys.length;
    var all = $('[data-kconv-select-all]');
    var boxes = $all('[data-kconv-select]');
    if (all) all.checked = boxes.length > 0 && keys.length === boxes.length;
  }

  /* -------------------------------------------------------------- collapse */
  function collapseKey() { return 'kconv-cart-collapsed'; }
  function getCollapsed() {
    try { return JSON.parse(sessionStorage.getItem(collapseKey()) || '[]'); } catch (e) { return []; }
  }
  function setCollapsed(arr) {
    try { sessionStorage.setItem(collapseKey(), JSON.stringify(arr)); } catch (e) {}
  }
  function restoreCollapse() {
    var col = getCollapsed();
    $all('.kconv-group').forEach(function (g) {
      var name = g.getAttribute('data-group');
      var isCol = col.indexOf(name) !== -1;
      g.classList.toggle('is-collapsed', isCol);
      g.setAttribute('aria-collapsed', isCol ? 'true' : 'false');
      var head = $('[data-kconv-group-toggle]', g);
      if (head) head.setAttribute('aria-expanded', isCol ? 'false' : 'true');
    });
  }
  function toggleGroup(g) {
    var name = g.getAttribute('data-group');
    var col = getCollapsed();
    var idx = col.indexOf(name);
    var willCollapse = idx === -1;
    if (willCollapse) col.push(name); else col.splice(idx, 1);
    setCollapsed(col);
    restoreCollapse();
  }

  function showMore(btn) {
    var body = btn.closest('.kconv-group__body');
    if (!body) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    $all('.kconv-ci--overflow', body).forEach(function (w) { w.hidden = expanded; });
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    var kc = root();
    var more = (kc && kc.dataset.i18nShowMore) || 'Toon nog';
    var less = (kc && kc.dataset.i18nShowLess) || 'Toon minder';
    btn.textContent = expanded ? (more + ' ' + btn.getAttribute('data-hidden-count')) : less;
  }

  /* --------------------------------------------------------------- kc-cards */
  function initRecs() {
    if (typeof window.initKCCards === 'function') {
      $all('[data-kconv-recs-track]').forEach(function (t) {
        try { window.initKCCards(t); } catch (e) {}
      });
    }
  }

  // Forceer lazy-images die na een innerHTML-swap niet meer geobserveerd
  // worden (anders blijven thumbnails op de blur-placeholder hangen).
  function activateLazyImages(container) {
    $all('img.image-lazy-loading[data-srcset]', container || document).forEach(function (img) {
      try {
        var ds = img.getAttribute('data-srcset');
        if (ds) img.srcset = ds;
        img.removeAttribute('data-srcset');
        img.classList.remove('image-lazy-loading', 'loading-animation--breathing');
      } catch (e) {}
    });
  }

  function afterRender() {
    var container = document.querySelector(DETAILS);
    applyEtas();
    restoreCollapse();
    syncBulk();
    activateLazyImages(container);
    // Bewaar het originele "Toon nog N"-label voor herstel na zoeken
    $all('[data-kconv-show-more]').forEach(function (b) {
      if (!b.dataset.labelMore) b.dataset.labelMore = b.textContent.trim();
    });
    // Herstel eventueel nog niet opgeslagen opmerking na een render-swap
    var note = $('[data-kconv-note]');
    if (note && noteValue !== null && note.value !== noteValue) note.value = noteValue;
  }

  /* ---------------------------------------------------------- delegation */
  document.addEventListener('click', function (e) {
    var kc = e.target.closest('.kconv-cart');
    if (!kc) return;

    var qtyBtn = e.target.closest('[data-qty-action]');
    if (qtyBtn) {
      e.preventDefault();
      var qwrap = qtyBtn.closest('[data-kconv-qty]');
      var input = $('.kconv-qty__input', qwrap);
      var key = qwrap.getAttribute('data-line-key');
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      var val = parseInt(input.value, 10) || min;
      if (qtyBtn.getAttribute('data-qty-action') === 'plus') { val += step; }
      else { val -= step; }
      if (val < min) val = qtyBtn.getAttribute('data-qty-action') === 'minus' && val < min ? 0 : min;
      if (max != null && val > max) val = max;
      if (val <= 0) { removeWithUndo(key); return; }
      input.value = val;
      changeLine(key, val);
      return;
    }

    var rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); removeWithUndo(rm.getAttribute('data-remove-line')); return; }

    var gt = e.target.closest('[data-kconv-group-toggle]');
    if (gt) { toggleGroup(gt.closest('.kconv-group')); return; }

    var sm = e.target.closest('[data-kconv-show-more]');
    if (sm) { showMore(sm); return; }

    var bulk = e.target.closest('[data-kconv-bulk-remove]');
    if (bulk) {
      var keys = selectedKeys();
      if (!keys.length) return;
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      bulkUpdate(updates).then(function () { analytics('bulk_remove', { count: keys.length }); toast(keys.length + ' verwijderd'); });
      return;
    }

    var dApply = e.target.closest('[data-kconv-discount-apply]');
    if (dApply) {
      var inp = $('[data-kconv-discount-input]', kc);
      if (inp) applyDiscount(inp.value.trim());
      return;
    }

    var recAdd = e.target.closest('[data-kconv-rec-add]');
    if (recAdd) {
      e.preventDefault();
      var card = recAdd.closest('[data-kconv-rec]');
      if (!card || busy) return;
      var sel = $('[data-kconv-rec-select]', card);
      var vid = sel ? sel.value : card.getAttribute('data-variant-id');
      if (!vid) return;
      busy = true;
      recAdd.classList.add('is-loading');
      fetchJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(withSections({ items: [{ id: vid, quantity: 1 }] }))
      })
        .then(function (res) { recAdd.classList.add('is-success'); analytics('rec_add', { variant: vid }); return applyResponse(res); })
        .catch(function (err) { recAdd.classList.remove('is-loading'); handleError(err); })
        .then(function () { busy = false; });
      return;
    }
  });

  var searchTimer = null;
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-kconv-search]')) {
      clearTimeout(searchTimer);
      var term = e.target.value;
      searchTimer = setTimeout(function () { runSearch(term); }, 150);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('.kconv-qty__input')) {
      var input = e.target;
      var key = input.getAttribute('data-line-key');
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : null;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < min) val = min;
      if (max != null && val > max) val = max;
      if (val <= 0) { removeWithUndo(key); return; }
      input.value = val;
      changeLine(key, val);
      return;
    }
    if (e.target.matches('[data-kconv-rec-select]')) {
      var opt = e.target.options[e.target.selectedIndex];
      var rcard = e.target.closest('[data-kconv-rec]');
      if (opt && rcard) {
        rcard.setAttribute('data-variant-id', opt.value);
        var pEl = $('[data-kconv-rec-price]', rcard);
        if (pEl) {
          var pr = parseInt(opt.getAttribute('data-price'), 10) || 0;
          var cp = parseInt(opt.getAttribute('data-compare'), 10) || 0;
          if (cp > pr) {
            pEl.innerHTML = '<span class="kconv-rec__price-now price">' + money(pr) + '</span><s class="kconv-rec__price-was">' + money(cp) + '</s>';
          } else {
            pEl.innerHTML = '<span class="kconv-rec__price-now price">' + money(pr) + '</span>';
          }
        }
      }
      return;
    }
    if (e.target.matches('[data-kconv-select]')) { syncBulk(); return; }
    if (e.target.matches('[data-kconv-select-all]')) {
      var on = e.target.checked;
      $all('[data-kconv-select]').forEach(function (c) {
        var wrap = c.closest('.kconv-ci-wrap');
        if (wrap && wrap.style.display === 'none') return; // respecteer zoekfilter
        c.checked = on;
      });
      syncBulk();
      return;
    }
  });

  /* -------------------------------------------------- opmerking (cart note) */
  var noteTimer = null;
  var noteSavedTimer = null;
  var noteValue = null;      // laatst getypte waarde (voor herstel na render)
  var noteSaved = null;      // laatst succesvol opgeslagen waarde

  function saveNote(value) {
    if (value === noteSaved) return Promise.resolve();
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    })
      .then(function () {
        noteSaved = value;
        var badge = $('[data-kconv-note-saved]');
        if (badge) {
          badge.hidden = false;
          clearTimeout(noteSavedTimer);
          noteSavedTimer = setTimeout(function () { badge.hidden = true; }, 2500);
        }
        analytics('note', {});
      })
      .catch(function (err) { handleError(err); });
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-kconv-note]')) return;
    noteValue = e.target.value;
    var badge = $('[data-kconv-note-saved]');
    if (badge) badge.hidden = true;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(noteValue); }, 600);
  });

  document.addEventListener('focusout', function (e) {
    if (!e.target.matches('[data-kconv-note]')) return;
    clearTimeout(noteTimer);
    saveNote(e.target.value);
  });

  /* -------------------------------------- externe cart-wijzigingen (cross-sell) */
  // De cross-sell-kaarten (kc-card-product) voegen zelf toe en vuren
  // 'cart:updated'. Wij verversen de cart-lijst zodat het product er direct in staat.
  var extTimer = null;
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.source === 'kconv-cart') return; // eigen broadcast
    if (busy || refreshing) return;
    clearTimeout(extTimer);
    extTimer = setTimeout(function () {
      if (!busy && !refreshing && document.querySelector(DETAILS)) refresh();
    }, 250);
  });

  /* ---------------------------------------------------- custom element/init */
  function boot() { afterRender(); initRecs(); }

  if ('customElements' in window && !customElements.get('kconv-cart')) {
    customElements.define('kconv-cart', class extends HTMLElement {
      connectedCallback() { boot(); }
    });
  } else {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})();
